import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { WebhookConfigListItem } from '@mangovoice/types'

import type { ApiError } from '../api/types'
import type { WebhooksApi } from '../api/webhooksApi'

interface UseListWebhooksParams {
  api: WebhooksApi
  pbxId: number
  options?: Omit<
    UseQueryOptions<WebhookConfigListItem[], ApiError>,
    'queryKey' | 'queryFn'
  >
}

export const useListWebhooks = ({
  api,
  pbxId,
  options,
}: UseListWebhooksParams): UseQueryResult<
  WebhookConfigListItem[],
  ApiError
> => {
  return useQuery<WebhookConfigListItem[], ApiError>({
    queryKey: ['webhooks', pbxId],
    queryFn: async () => {
      const response = await api.listWebhooks(pbxId)

      if (!response.ok) {
        return Promise.reject(response.data as ApiError)
      }

      return response.data!.results
    },
    enabled: pbxId > 0,
    ...options,
    retry: options?.retry ?? false,
  })
}
